/**
 * Created by alvinoktavianus on 5/18/17.
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'

import PageWrapper from 'components/wrappers/pages/PageWrapper/PageWrapper'
import { hidePaymentGatewayErrorModal } from 'actions/setting/billing/index'
import { billingPageRequest } from 'actions/setting/billing'
import BillingHistory from './BillingHistory'
import BillingReceipt from './BillingReceipt'
import ActiveOutlets from './ActiveOutlets'
import CurrentPlan from './CurrentPlan'
import FeatureSubscriptions from './FeatureSubscriptions'
import PaymentGatewayErrorModal from 'components/PaymentGatewayErrorModal'
import styles from './Billing.css'
import MenuTitle from 'components/MenuTitle'

class Billing extends Component {
  render () {
    const {showPaymentGatewayErrorModal, totalBillingPrice, showLoadingSpinnerPage} = this.props
    let isLoading = `${styles['mr-loading']}`
    let isNotLoading = ``

    return (
      <div>
        <PageWrapper>
          <div className={`row visible-below-1440px`}>
            <div className={`${!showLoadingSpinnerPage ? isNotLoading : isLoading} col-xs-12 col-md-5`}>
              <MenuTitle menuTitle='Billing' />
              <CurrentPlan />
              <ActiveOutlets />
              <FeatureSubscriptions />
            </div>
            <div className={`${!showLoadingSpinnerPage ? isNotLoading : isLoading} col-xs-12 col-md-7`}>
              <BillingReceipt />
            </div>
          </div>
          <div className={`row visible-above-1440px`}>
            <div className={`${!showLoadingSpinnerPage ? isNotLoading : isLoading} col-xs-12 col-md-6`}>
              <MenuTitle menuTitle='Billing' />
              <CurrentPlan />
              <ActiveOutlets />
              <FeatureSubscriptions />
            </div>
            <div className={`${!showLoadingSpinnerPage ? isNotLoading : isLoading} col-xs-12 col-md-6`}>
              <BillingReceipt />
            </div>
          </div>
          <div className='row'>
            <div className={!showLoadingSpinnerPage ? 'col-xs-12' : `col-xs-12 ${styles['mr-loading']}`}>
              <BillingHistory />
            </div>
          </div>
        </PageWrapper>
        <PaymentGatewayErrorModal
          showModal={showPaymentGatewayErrorModal}
          onHide={this._onHide}
          totalPrice={totalBillingPrice}
        />
      </div>
    )
  }

  componentDidMount () {
    let {current_plan, expired, is_owner, billingNotification} = this.props
    this.props.dispatch(billingPageRequest(current_plan, expired, is_owner, billingNotification))
  }

  _onHide = () => {
    this.props.dispatch(hidePaymentGatewayErrorModal())
  }
}

function mapStateToProps (state) {
  let {is_owner, business: {current_plan}} = state.moka.user
  let {showPaymentGatewayErrorModal, totalBillingPrice} = state.setting.billing
  let {nextActionExpired, expired} = state.subscriptionExpired
  let {billingNotification} = state
  let {showLoadingSpinnerPage} = state.loadingSpinner
  return {
    showPaymentGatewayErrorModal,
    totalBillingPrice,
    current_plan,
    nextActionExpired,
    expired,
    is_owner,
    billingNotification,
    showLoadingSpinnerPage
  }
}

export default connect(mapStateToProps)(Billing)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Billing/Billing.js